import { logout } from "../components/auth/api/authApi";
import { useQueryClient } from "@tanstack/react-query";
import { GET_SAVED_PAYMENT_METHODS_QUERY_KEY } from "../components/payments/api/paymentApi";
import { AxiosResponse } from "axios";
import { ServerListResponse } from "../types";
import { pendingAuthPaymentConfigStore } from "../hookstate/pendingAuthPaymentConfigStore";
import { setFunnelModalConfig } from "../components/funnel/FunnelModal";
import { useRefetchAccountAndRelease } from "./useRefetchAccountAndRelease";
import { clearAllPendingPaymentState } from "../components/payments/utils/clearAllPendingPaymentState";

export function useHandleLogout() {
  const queryClient = useQueryClient();
  const refetchQueries = useRefetchAccountAndRelease();

  return async () => {
    try {
      await logout();
    } catch (e) {}

    // Clear all entity caches that could contain user state
    queryClient.removeQueries({
      predicate: (query) => {
        const key = query.queryKey[0] as string;
        return (
          typeof key === "string" &&
          key.includes("-") &&
          (key.startsWith("Comic-") ||
            key.startsWith("Artist-") ||
            key.startsWith("Release-"))
        );
      },
    });

    queryClient.setQueryData(
      GET_SAVED_PAYMENT_METHODS_QUERY_KEY,
      (oldData: AxiosResponse<ServerListResponse<any>>) => {
        if (oldData) oldData.data.payload.results = [];
        return oldData;
      },
    );

    pendingAuthPaymentConfigStore.set(undefined);
    clearAllPendingPaymentState();
    setFunnelModalConfig();

    // Even if the logout fails, we want to invalidate the account data.
    // That should never stay if the user is "logging" out.
    try {
      await refetchQueries();
    } catch {
      // Swallow refetch errors — the user is logging out regardless.
    }
  };
}
